import { ChangeEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Autocomplete } from '@react-google-maps/api'
import { TextField } from '@mui/material'

interface IProps {
  error?: string
  id: string
  handleAddress: (address: string) => void
  value: string | null
}

export const AddressInput = ({ error, id, handleAddress, value }: IProps) => {
  const [t] = useTranslation()
  const [autocomplete, setAutocomplete] = useState<google.maps.places.Autocomplete | null>(null)

  const handleAddressChange = (e: ChangeEvent<HTMLInputElement>) => {
    handleAddress(e.target.value)
  }

  const handleAutocompleteLoad = (a: google.maps.places.Autocomplete) => {
    setAutocomplete(a)
  }

  const handleAutocompletePlaceChanged = () => {
    if (!autocomplete) return
    const place = autocomplete.getPlace()
    place.formatted_address && handleAddress(place.formatted_address)
  }

  return (
    <Autocomplete
      onLoad={handleAutocompleteLoad}
      onPlaceChanged={handleAutocompletePlaceChanged}
      options={{ fields: ['formatted_address', 'geometry'] }}
    >
      <TextField
        autoComplete="off"
        fullWidth
        label={t('account-form-address-label.v')}
        helperText={error}
        value={value || ''}
        name={id}
        variant="standard"
        FormHelperTextProps={{
          error: !!error,
        }}
        onChange={handleAddressChange}
      />
    </Autocomplete>
  )
}
